module.exports = __webpack_public_path__ + "static/media/8OLA6.d2ab1066.jpg";